import { render, staticRenderFns } from "./RootConfig.vue?vue&type=template&id=339b1bb8&"
import script from "./RootConfig.vue?vue&type=script&lang=ts&"
export * from "./RootConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports